import * as THREE from 'three';
import { createRenderer } from './renderer.js';
import { createLights } from './lights.js';

/**
 * The boot scene: renderer, lights, sky colour and a render hook.
 *
 * The camera is *not* here, unlike the usual arrangement. The camera is a rig
 * that needs to know about the level's collision before it can exist, and the
 * stage has to exist before the level is built — so the rig owns its own camera
 * and hands it back to the stage at render time.
 */
export function createStage(canvas, camera) {
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0x10131a);
  scene.fog = new THREE.Fog(0x10131a, 40, 130);

  const { renderer, dispose } = createRenderer(canvas, camera);
  const [ambient, key] = createLights();
  scene.add(ambient);
  scene.add(key);

  return {
    scene,
    camera,
    renderer,
    /** The two lights every scene has. `world/look` sets them by the hour. */
    lights: { ambient, key },
    render() {
      renderer.render(scene, camera);
    },
    dispose,
  };
}
